import { CommonModule } from '@angular/common';
import { Component, computed, Input, output, signal } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { words } from 'lodash';

@Component({
  selector: 'smata-menu-profile',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './menu-profile.component.html',
  styleUrl: './menu-profile.component.scss',
})
export class MenuProfileComponent {
  @Input() userDisplayName: string = '';
  public logout = output<void>();

  displayName = computed<string>(() => {
    return this.userDisplayName;
  });

  initials = computed(() => {
    const name = this.displayName();

    const nameWords = words(name);

    if (nameWords.length > 1) {
      return (nameWords[0].charAt(0) + nameWords[1].charAt(0)).toUpperCase();
    }

    if (nameWords.length === 1) {
      return nameWords[0].slice(0, 2).toUpperCase();
    }

    return '??';
  });

  menuOpen = signal(false);

  public onLogoutClick(): void {
    this.logout.emit();
  }
}
